import { styled } from '@mui/material/styles';

export const StyledSvg = styled('svg')`
    vertical-align: middle;
`;
